<template>
  <a>
    <span>Unable to submit some events. Please check for</span><br/>
    <ul>
      <br/>
      <li>Incomplete information. Please fill in required information and continue submitting</li><br/>
      <li>Events requested within 90 days. Normal event scheduling requires advanced notice of 90 days. Please choose dates that meet these requirements or contact ADURO for assistance.</li>
    </ul>
    <span class="modal-body-text">All completed events have been submitted.</span>
  </a>
</template>

<script>
export default {
  name: 'submit-all-body-modal'
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// SubmitAllEventEmptyFieldsAnd90DaysError.vue?7c3ac8c9